import { publicDomain } from "./publicDomain.js";
/**
 * Deep link into tenant management (`/management/tenant` on the bare `apps.<domain>` host) scoped to
 * a specific Descope tenant. The tenant is carried in the URL path (`/management/tenant/:tenantId/…`)
 * — the single source of truth for the target tenant — so the link lands directly on that tenant's
 * management screens rather than the generic picker. There is no `?tenant=` query form.
 */
export function managementTenantUrl(descopeId, page = 'users') {
    return `https://apps.${publicDomain()}/management/tenant/${encodeURIComponent(descopeId)}/${page}`;
}
//# sourceMappingURL=managementUrl.js.map